<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="12" md="10" lg="8">
        <v-card>
          <v-card-title>
            <v-icon left>fas fa-truck</v-icon>
            Project Shipments
          </v-card-title>
          <v-data-table
            :items="items"
            :headers="headers"
            dense
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// TODO Currently Ticket Number isn't in the query. Fix JSON response for this.
// TODO Update table so that it is aesthetic
import { ShippingItem } from "../../models/Shipping";
export default {
  name: "ProjectShippingListView",
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      headers: [
        { text: "Ticket", align: "left", sortable: true, value: "ticket.name" },
        { text: "Batch", sortable: true, value: "batch.forgeID" },
        {
          text: "quantity",
          sortable: true,
          value: "quantity",
        },
        {
          text: "Notes",
          sortable: true,
          value: "notes",
        }
      ]
    }
  },
  computed: {
    items() {
      return ShippingItem.query()
        .whereHas("batch", (query => {
          query.where("project", parseInt(this.id))
        }))
        .with("batch")
        .with("ticket")
        .get();
    }
  }
}
</script>
